import React from "react"
import PropTypes from "prop-types"
import { Link as GatsbyLink } from "gatsby"

import { Typography, makeStyles, Box, Button } from "@material-ui/core"

import BgImage from "./background-image"

const useStyles = makeStyles(theme => ({
  bgImage: {
    height: props => (props.isIndex ? "80vh" : "70vh"),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "0 20px",
    "&::before, &::after": {
      [theme.breakpoints.down("sm")]: {
        backgroundPosition: "50%",
      },
    },
    "&.about": {
      alignItems: "start",
      paddingLeft: "100px",
      [theme.breakpoints.down("sm")]: {
        padding: "0 20px",
        alignItems: "center",
      },
    },
  },
  containerText: {
    "&.index": {
      textAlign: "center",
    },
  },
  button: {
    marginRight: theme.spacing(3.75),
    [theme.breakpoints.down("sm")]: {
      margin: "10px 0",
    },
  },
}))

const Hero = props => {
  const {
    imgName,
    title,
    subtitle,
    primaryBtnLabel,
    primaryBtnHref,
    secondaryBtnLabel,
    secondaryBtnHref,
    ...rest
  } = props
  const classes = useStyles(props)

  return (
    <BgImage
      className={classes.bgImage}
      style={{ backgroundPosition: "" }}
      imgName={imgName}
      {...rest}
    >
      <Box
        className={classes.containerText}
        maxWidth="850px"
        textAlign={{ xs: "center", md: "left" }}
      >
        <Typography variant="h1" gutterBottom>
          {title}
        </Typography>
        <Typography variant="subtitle1">{subtitle}</Typography>
      </Box>
      <Box
        mt={3.75}
        textAlign="center"
        display={{ xs: "flex", md: "block" }}
        flexDirection="column"
        alignItems="center"
      >
        {secondaryBtnLabel && (
          <Button
            className={classes.button}
            component={GatsbyLink}
            to={secondaryBtnHref}
            color="secondary"
            variant="contained"
          >
            {secondaryBtnLabel}
          </Button>
        )}
        <Button color="primary" variant="contained" href={primaryBtnHref}>
          {primaryBtnLabel}
        </Button>
      </Box>
    </BgImage>
  )
}

Hero.propTypes = {
  imgName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  primaryBtnLabel: PropTypes.string,
  primaryBtnHref: PropTypes.string,
  secondaryBtnLabel: PropTypes.string,
  secondaryBtnHref: PropTypes.string,
}

export default Hero
